import { CancelButton, Card, CommandButton } from "components"
import { ModalJournalInvoice } from "./ModalJournalInvoice"
import { useToggle } from "utils"
import { AttachmentModal } from "./AttachmentModal"
import { Print } from "./Print"
// import { useParams } from "react-router-dom"
// import { useFormContext, useWatch } from "react-hook-form"
// import { FormInvoiceType } from "../types"

type CommandButtonsProps = {
  approvalView?: boolean
  showSaveButton?: boolean
  showDeleteButton?: boolean 
  customElements?:React.ReactNode
  onDelete?: () => void
  onSave?: () => void
}

export const CommandButtons = ({
  approvalView,
  showSaveButton,
  showDeleteButton,
  customElements,
  onDelete,
  onSave
}: CommandButtonsProps) => {
  const modalJournalInvoice = useToggle(false)
  // const { invoice_id } = useParams()

  // const { control } = useFormContext<FormInvoiceType>()
  // const approval_status = useWatch({ control, name: "approval_status" })

  return (
    <>
      <Card className={approvalView ? "hidden" : ""}>
        <Card.Body className="flex flex-col gap-5">
          <section className="flex flex-wrap justify-between gap-3">
            <section className="flex flex-wrap gap-3">
              {/* {invoice_id && approval_status === 4 ? <Print /> : <CommandButton actiontype="print" />} */}
              <Print />
              
              <CommandButton
                actiontype="journal"
                onClick={modalJournalInvoice.toggle}
              />
              <AttachmentModal/>

              {customElements}
            </section>

            <section className="flex flex-wrap gap-3">
              <CancelButton />

              {showDeleteButton && (
                <CommandButton actiontype="delete" onClick={onDelete} />
              )}

              {showSaveButton && (
                <CommandButton
                  actiontype="save"
                  type="button"
                  color="primary"
                  permission="ST121"
                  onClick={onSave}
                />
              )}
            </section>
          </section>
        </Card.Body>
      </Card>

      <ModalJournalInvoice
        isOpen={modalJournalInvoice.isActive}
        toggle={modalJournalInvoice.toggle}
      />
    </>
  )
}
